import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/student.png'


const _withScopeId = n => (_pushScopeId("data-v-60d3461c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["href", "target"]
const _hoisted_3 = { class: "ellipsis" }
const _hoisted_4 = { class: "horizontal" }
const _hoisted_5 = { class: "imgWrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "HeartAnimation" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "いいね", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "horizontal" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "募集職種", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "給与", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "liLabel" }, "勤務地", -1))
const _hoisted_13 = {
  key: 0,
  class: "fromStudentWrap"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "textWithRating" }, "学生からの評価", -1))
const _hoisted_15 = { class: "textWithRating" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "studentImage",
  src: _imports_0,
  alt: "Student"
}, null, -1))
const _hoisted_17 = { style: {"width":"calc(100% - 55px)"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "きっかけ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_image = _resolveComponent("n-image")!
  const _component_n_rate = _resolveComponent("n-rate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrap", _ctx.liked ? 'liked' : '']),
    id: _ctx.from === 'search' ? `h_${_ctx.apply.id}` : ''
  }, [
    _createElementVNode("a", {
      href: `/apply/${_ctx.apply.id}`,
      target: _ctx.from === 'sitemap' ? '' : `_blank`,
      class: "title"
    }, _toDisplayString(_ctx.apply.hospitalName), 9, _hoisted_2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.apply.prPoint), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_n_image, {
          width: "250",
          "object-fit": "cover",
          height: "250",
          src: _ctx.apply.attachedFiles[0].url
        }, null, 8, ["src"]),
        _createElementVNode("div", {
          class: "horizontal likeWrap",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.like(_ctx.id)))
        }, _hoisted_8)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.getJobType(_ctx.apply.type)), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(_ctx.getSalary(_ctx.apply.salary)), 1)
            ]),
            _createElementVNode("li", null, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.apply.location), 1)
            ])
          ])
        ]),
        (_ctx.apply.reviews)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", null, [
                _hoisted_14,
                (_ctx.rateCeil > 0)
                  ? (_openBlock(), _createBlock(_component_n_rate, {
                      key: 0,
                      readonly: "",
                      "default-value": _ctx.rateCeil,
                      "allow-half": ""
                    }, null, 8, ["default-value"]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.rateDetails || 0), 1)
              ]),
              (_ctx.apply.reviews[0])
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fromStudent horizontal",
                    onClick: _cache[1] || (_cache[1] = () => _ctx.goToReview(_ctx.id))
                  }, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.apply.reviews[0].option1.substr(0, 10)) + "… ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_20, "計" + _toDisplayString(_ctx.count) + "件", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 10, _hoisted_1))
}